// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"corporate-gifts-banner_mainContainer__xBq3u","titleTextContainer":"corporate-gifts-banner_titleTextContainer__oLfB5"};